import { createContext, FC, ReactNode, useMemo, useState } from 'react';
import { MultiValue } from 'react-select';
import {
  AdminTokenUsageContextValues,
  AdminTokenUsageTotalTable,
} from '@features/admin-token-usage/types';
import { Option } from '@utils/react-select.ts';
import dayjs from 'dayjs';

const AdminTokenUsageContext = createContext<
  AdminTokenUsageContextValues | undefined
>(undefined);

interface AdminTokenUsageProviderProps {
  children: ReactNode;
}

const AdminTokenUsageProvider: FC<AdminTokenUsageProviderProps> = ({
  children,
}) => {
  const [showTokenCount, setShowTokenCount] = useState<boolean>(true);
  const [selectedInterval, setSelectedInterval] = useState<Option>({
    value: 'month',
    label: 'Month',
  });
  const [startDate, setStartDate] = useState<Date | null>(
    dayjs().startOf('year').toDate()
  );
  const [endDate, setEndDate] = useState<Date | null>(
    dayjs().endOf('year').toDate()
  );
  const [documentResult, setDocumentResult] = useState<Option>({
    value: 'total',
    label: 'All',
  });
  const [selectedDocumentTypes, setSelectedDocumentTypes] = useState<
    MultiValue<Option>
  >([
    { value: 'demand_letter', label: 'Demand Letters' },
    { value: 'deposition_summary', label: 'Deposition Summaries' },
    { value: 'use_case', label: 'Use Cases' },
  ]);
  const [totalTableData, setTotalTableData] =
    useState<AdminTokenUsageTotalTable | null>(null);

  const contextValue = useMemo(
    () => ({
      showTokenCount,
      setShowTokenCount,
      selectedInterval,
      setSelectedInterval,
      documentResult,
      setDocumentResult,
      selectedDocumentTypes,
      setSelectedDocumentTypes,
      startDate,
      setStartDate,
      endDate,
      setEndDate,
      totalTableData,
      setTotalTableData,
    }),
    [
      showTokenCount,
      setShowTokenCount,
      selectedInterval,
      setSelectedInterval,
      documentResult,
      setDocumentResult,
      selectedDocumentTypes,
      setSelectedDocumentTypes,
      startDate,
      setStartDate,
      endDate,
      setEndDate,
      totalTableData,
      setTotalTableData,
    ]
  );

  return (
    <AdminTokenUsageContext.Provider value={contextValue}>
      {children}
    </AdminTokenUsageContext.Provider>
  );
};

export { AdminTokenUsageProvider, AdminTokenUsageContext };
